import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "timeline-view" }

import { getCurrentInstance, onMounted, ref } from "vue";
import { Timeline } from "vis-timeline";
import { DataSet } from "vis-data";
import { useDataStore } from "@/store/data-store";
import ProjectTile from "@/components/Pages/ProjectTile.vue";
import { Utils } from "@/classes/utils/utils";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineView',
  setup(__props) {

const dataStore = useDataStore();
const router = useRouter();

const currentInstance = getCurrentInstance();
const timelineElement = ref(null);

onMounted(async () => {
	const projects = await dataStore.getProjects();

	// Create a DataSet (allows two way data-binding)
	var data = new DataSet();
	var groups: any[] = [];

	for (const project of projects) {
		const entry = {
			id: project.uuid,
			content: project.name,
			group: project.uuid,
			start: project.firstSurveyDate || project.lastUpdateDate,
			project: project,
		}
		if(project.lastSurveyDate && project.firstSurveyDate?.getTime() !== project.lastSurveyDate?.getTime()){
			entry.end = project.lastSurveyDate;
		}
		data.add(entry)

		groups.push({
			id: project.uuid,
			title: project.name,
			content: project.name,
		});
	}

	const height = window.innerHeight - 200;

	console.log("Timeline");

	// Create a Timeline
	const timeline = new Timeline(timelineElement.value, data, {
		height: height,
		orientation: "top",
		template: function (item, element, data) {
			var projectTile = Utils.mount(ProjectTile, {
				props: {
					project: data.project,
					showEditButton: false,
					showProjectStatus: false,
					openOnClick: false
				},
				context: currentInstance.appContext
			}).el;
			return projectTile;
		},
	});
	timeline.on("select", (props) => {
		const projectId = props.items[0];
		const project = projects.find(p=>p.uuid == projectId);
		if(!Utils.canViewProject(project)){
			return;
		}
		if (projectId) {
			router.push({ name: "view", params: { projectId: projectId} })
		}
	})
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "timelineElement",
      ref: timelineElement,
      id: "vis-timeline"
    }, null, 512)
  ]))
}
}

})